import _extends from "@babel/runtime/helpers/esm/extends";
var _circle, _circle2, _circle3;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgThreeDot = function SvgThreeDot(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: 16,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 2.4,
      cy: 2.095,
      r: 2.01,
      fill: "#6D7179"
    })), _circle2 || (_circle2 = /*#__PURE__*/_jsx("circle", {
      cx: 8.029,
      cy: 2.095,
      r: 2.01,
      fill: "#6D7179"
    })), _circle3 || (_circle3 = /*#__PURE__*/_jsx("circle", {
      cx: 13.657,
      cy: 2.095,
      r: 2.01,
      fill: "#6D7179"
    }))]
  }));
};
export default SvgThreeDot;